<template>
  <div :class="`login-bg ${props.type}`"><p class="login-bg-tip"></p></div>
</template>

<script setup>
const props = defineProps({
  type: {
    type: String,
    default: '',
  },
})
</script>
<style lang="scss" scoped>
.login-bg {
  flex: 1;
  height: 100%;
  background: #ECF1FF url(@/assets/login-bg.png) center no-repeat;
  background-size: cover;
  position: relative;
}
</style>
